export var FirebaseDoc;
(function (FirebaseDoc) {
    FirebaseDoc["GameRoles"] = "gameRoles";
    FirebaseDoc["DevOpsMaturities"] = "devOpsMaturities";
})(FirebaseDoc || (FirebaseDoc = {}));
